import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';

import Box from 'components/uikit/Box';

import PmList from 'components/pm/PmList';


//import ShortPmList from 'local-pm-js/build/components/ShortPmList';
import ShortPmList from 'pm-js/build/components/ShortPmList';

//import PmConversation from 'local-pm-js/build/components/PmConversation';
import PmConversation from 'pm-js/build/components/PmConversation';

import { t, dt, getLangPrefix } from 'l10n';
import paths from 'paths';

import Loading from 'components/Loading';
import PmPageHeader from 'components/pm/PmPageHeader';
import PmListItem from 'components/pm/PmListItem';
import PmConversationHeader from 'components/pm/PmConversationHeader';

import { Link, LocalizedLink } from 'components/ReactRouterDomLocalized';
import {getPaymentUrl, getReturnPath} from 'utils/url';

import {
    getMemberMessageList,
    clearMessageListInMemory
} from 'reducers/memberMessageList';

//import 'pm-js/build/sass/pm.scss';
import 'sass/pm.scss';

class MessagePmConversations extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingScroll: false,
            showTopButton: false,
            showXxl: false
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.onListClick = this.onListClick.bind(this);
        this.onSuggestSelect = this.onSuggestSelect.bind(this);
        this.listFilterFn = this.listFilterFn.bind(this);
        this.path = this.path.bind(this);
        if (props.match.params.id) {
            this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation_uid: props.match.params.id});
            this.state.currentConversation = props.match.params.id;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pm.status != "connected") {
            this.setState({currentConversation: null});
        } else {
            if (nextProps.match.params.id) {
                let conversation = nextProps.pm.conversations[nextProps.match.params.id];
                if (this.state.currentConversation != nextProps.match.params.id) {                    
                    if (conversation) {
                        if (this.state.currentConversation) {
                            this.props.dispatch({type: "PM_WINDOW_MINIMIZE", conversation_uid: this.state.currentConversation});
                        }

                        this.setState({currentConversation: nextProps.match.params.id});
                        this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation_uid: conversation.user.uid});
                    }
                }

                if (conversation) {
                    let newFilter = this.whereConversationBelongs(conversation);
                    if (newFilter != this.props.filter) {
                        this.props.history.replace(this.path(conversation.user.uid, newFilter));
                    }
                }
            } else {
                let activeConversation = null;
                for (let uid in this.props.pm.conversations) {
                    if (nextProps.pm.conversations[uid].view.maximized) {
                        activeConversation = nextProps.pm.conversations[uid];
                    }
                }      

                if (activeConversation) {
                    this.setState({currentConversation: null});
                    this.props.dispatch({type: "PM_WINDOW_MINIMIZE_ALL"});
                }
            }

        }


    }

    componentWillUnmount() {
        document.getElementsByTagName("html")[0].classList.remove("member-page-pm");
    }

    handleScroll(e) {
        const {
            scrollTop,
            scrollHeight,
            clientHeight,
        } = e.target.scrollingElement;
        let innerHeight = window.innerHeight;
        const bottom = scrollTop + innerHeight == scrollHeight;

        const {
            offset,
            totalCount
        } = this.props.memberMessageList;

        this.setState({showTopButton: scrollTop !== 0})

        if(scrollTop !== 0 && bottom && offset !== totalCount) {
            const { dispatch, location } = this.props;

            const params = {
                offset: offset
            };

            this.setState({pendingScroll: true})

            let action = this.fetchData(params);
            dispatch(action);
                    
            action.promise
                .then(() => {
                    this.setState({pendingScroll: false})
                })
                .catch((e) => this.setState({pendingScroll: false}));
        }
    }

    path(id, filter) {
        let path;
        if (!filter) filter = this.props.filter;
        if (filter == "requests") {
            path = paths.memberMessagePmRequests.path;
        } else if (filter == "archive") {
            path = paths.memberMessagePmArchive.path;
        } else {
            path = paths.memberMessagePmConversations.path;
        }

        if (id) {
            path += "/" + id;
        }

        return (getLangPrefix() || '') + path;
    }

    onListClick(conversation) {
        this.props.history.push(this.path(conversation.user.uid));
        
       // this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation: conversation, user:conversation.user})
    }

    onSuggestSelect(user) {
        if (!user) return;
        let uid = user.id;
        if (!uid) return;

        let xxl = this.props.currentUser.isXXL();
        if (!xxl) {
            this.setState({showXxl: true});
            return;
        }


        if (this.props.pm.conversations[uid]) {
            this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation_uid: uid});
        } else {
            this.props.dispatch({type: "PM_PERFORM_PM_REQUEST", conversation_uid: uid});
        }

        this.props.history.push(this.path(uid));
    }

    calculateArchiveCount() {
        const archive = Object.values(this.props.pm.conversations).filter(this.listFilterFn("archive"));

        return archive.length;
    }

    listFilterFn(filter) {
        if (!filter) filter = this.props.filter;

        return function(conv) {
            const isHistoryDeleted = conv.historyDeleted.status;

            if (filter == "requests") {
                 return (conv.generalStatus == "requested_by_me");
            } else if (filter == "archive") {
                const deniedByMe = conv.generalStatus == "denied_by_me";
                const blockedByMe = conv.generalStatus == "blocked_by_me";
                const blockedByRecipient = conv.generalStatus == "blocked_by_recipient";
                return (
                    (isHistoryDeleted && conv.generalStatus == "allowed")
                    || deniedByMe || blockedByMe || blockedByRecipient)
            } else {
                return ( (!isHistoryDeleted && conv.generalStatus == "allowed") || conv.generalStatus == "requested_by_recipient");
            }
        }
    }

    whereConversationBelongs(conv) {
        if (!conv) return "requests";
        if (this.listFilterFn("requests")(conv)) {
            return "requests";
        } else if (this.listFilterFn("archive")(conv)) {
            return "archive";
        }

        return "conversations";
    }

    onRevoke() {
        this.props.history.push(this.path());
    }

    renderEmpty() {
        return <div className="empty-list">{t('No messages')}</div>;
    }

    renderNoXxl() {
        return <div className='content-no-xxl-member'>
                    <div className='text'>
                        <p>{t("You need to become XXL to use this feature.")}</p>
                        <p></p>
                        <LocalizedLink to={getPaymentUrl(getReturnPath())} className='get-xxl-button'>{dt('wall_material', 'Become an XXL member')}</LocalizedLink>
                    </div>
                </div>
    }

    render() {
        window.requestAnimationFrame(() => {
                document.getElementsByTagName("html")[0].classList.add("member-page-pm");
            });
        if (this.props.pm.status != "connected") {
            return <Loading />;
        }

        let activeConversation = null;
        if (this.state.currentConversation) {
            activeConversation = this.props.pm.conversations[this.state.currentConversation];
        }    

        let containerClasses = ["pm-conversations-container", "contents"];
        let pageClasses = ["pm-conversations-page"];
        let showForm = true;
        if (activeConversation) {
            containerClasses.push("with-conversation-open");
            pageClasses.push("with-conversation-open");
            //showForm = false;
        } else {
            containerClasses.push("no-conversation-open");
            pageClasses.push("no-conversation-open");
        }

        let anyItems = Object.values(this.props.pm.conversations).filter(this.listFilterFn());

        

        return (

            <div className={pageClasses.join(" ")}>
                {<PmPageHeader
                    showForm={true}
                    title={t('Private messages')}
                    onNewMessage={this.onSuggestSelect}
                    requestsCount={this.props.pm.counters.requested_by_me }
                    archiveCount={this.calculateArchiveCount()}
                    conversationsCount={this.props.pm.counters.allowed_unread + this.props.pm.counters.requested_by_recipient}

                />}
                {activeConversation ? <div className="link-back"><Link to={this.path()} className="back-message">{t('Back to Messages list')}</Link></div> : null}
                

                    <div className={containerClasses.join(" ")}>

                    {this.state.showXxl ? 
                        this.renderNoXxl() :

                        (anyItems.length == 0 ? 
                            <div className="empty-list">{t('No messages')}</div>
                            :
<Fragment>




                       



                    
                        <Box className="pm-conversations" direction="row">
                            <Box className="left-panel">
                                <Scrollbars>
                                <PmList
                                    conversations={this.props.pm.conversations}
                                    filterFn={this.listFilterFn()}
                                    pathFn={this.path}
                                    onItemClick={this.onListClick}/>
                                </Scrollbars>
                            </Box>    
                            <Box className="right-panel">
                            {
                                anyItems.length > 0 ? 
                                    (activeConversation ? 
                                        <div className="pm-conversation-item">
                                            <PmConversationHeader pmConversation={activeConversation} backPath={this.path()} onRevoke={this.onRevoke.bind(this)}/>
                                            <PmConversation loading={<Loading/>} pmConversation={activeConversation}/>
                                        </div> : null)
                                    : <div className="empty-list">{t('No messages')}</div>
                            }
                            </Box>
                        </Box>
</Fragment>
                        ) }
                    </div>
            </div>
        )
    }
}



export default connect(
    state => ({
        currentUser: state.currentUser,
        pm: state.pm
    }),
    null
)(withRouter(MessagePmConversations));


// WEBPACK FOOTER //
// ./src/containers/member/MessagePmConversations.js